import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiMenu } = FiIcons;

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Beranda', path: '/' },
    { name: 'Tentang Kami', path: '/about' },
    { name: 'Layanan', path: '/services' },
    { name: 'Jaringan', path: '/network' },
  ];

  const handleCalculatorClick = () => {
    setMobileMenuOpen(false);
    if (location.pathname !== '/') {
      window.location.href = '/#calculator-section';
    } else {
      document.getElementById('calculator-section')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled || location.pathname !== '/' ? 'bg-navy/95 backdrop-blur-md shadow-lg py-4' : 'bg-transparent py-6'}`}>
      <div className="max-w-[1200px] mx-auto px-6 flex justify-between items-center">
        
        {/* Logo Updated */}
        <Link to="/" className="flex items-center">
          <img 
            src="/Logo-NIL.png" 
            alt="Nusantara Logistik" 
            className="h-10 md:h-12 w-auto object-contain"
          />
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link 
              key={link.name} 
              to={link.path} 
              className={`text-sm transition-colors hover:text-white ${location.pathname === link.path ? 'text-white font-bold border-b-2 border-orange pb-1' : 'text-slate-300 font-medium'}`}
            >
              {link.name}
            </Link>
          ))}
        </div>

        {/* Action Buttons */}
        <div className="hidden md:flex items-center gap-4">
          <button 
            onClick={handleCalculatorClick}
            className="bg-[#e46135] hover:bg-[#c54a22] text-white px-6 py-2 rounded-full text-sm font-bold transition-all"
          >
            Kalkulator Pengiriman
          </button>
        </div>

        {/* Mobile Toggle */}
        <button 
          className="md:hidden text-white text-2xl"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-navy border-t border-white/10 py-4 px-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link 
              key={link.name} 
              to={link.path} 
              onClick={() => setMobileMenuOpen(false)}
              className={`text-lg transition-colors w-fit ${location.pathname === link.path ? 'text-white font-bold border-b-2 border-orange pb-1' : 'text-slate-300 font-medium hover:text-white'}`}
            >
              {link.name}
            </Link>
          ))}
          <button 
            onClick={handleCalculatorClick}
            className="bg-[#e46135] hover:bg-[#c54a22] text-white px-6 py-3 rounded-xl text-center font-bold mt-2 transition-colors"
          >
            Kalkulator Pengiriman
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;